<template>
  <div v-if="!editorOpen" :class="collapsed ? 'collapsed' : ''" id="settingsPanel">
    <div
      class="hover-wrapper"
      :tooltip="editorOpen ? $t('editor-sidepanel.hover') : ''"
      tooltip-placement="left"
    >
      <!-- disabled-btn is temporary until new conditions and variables popover are fixed -->
      <div
        @click="collapsed = !collapsed"
        class="collapser"
        :class="editorOpen ? 'disabled-btn' : ''"
      >
        <!-- <span class="variation-count">{{ $t("editor-sidepanel.hide")}}</span> -->
        <span class="variation-count">Data</span>
        <div :class="{ 'flip-chevron': collapsed }">
          <i class="fa-light fa-chevron-double-right"></i>
        </div>
      </div>
    </div>
    <variables class="panel-area" />
    <!-- <preview
				:preview="$store.state.sentenceEditorPreview"
				class="panel-area"
				v-if="$store.state.sentenceEditorPreview"
		/> -->
    <!-- <synonym-list/> -->
  </div>
</template>

<script>
import Variables from "@/components/Variables";
import Preview from "@/components/Preview";
import EventBus from "@/assets/js/eventBus.js";
export default {
  data() {
    return {
      collapsed: false,
      editorOpen: false,
    };
  },
  props: {
    isCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    collapsed: function() {
      if (this.collapsed) {
        EventBus.$emit("move_popover_back");
        EventBus.$emit("move_var_popover_back");
      }
      if (!this.collapsed) {
        EventBus.$emit("move_popover_left");
        EventBus.$emit("move_var_popover_left");
      }
    },
  },
  methods: {
    //Test for potential redesign
    closePanel() {
      this.collapsed = true;
      this.editorOpen = true;
    },
    openPanel() {
      this.collapsed = false;
      this.editorOpen = false;
    },
    enableComparisonView() {
      this.collapsed = true;
    },
    unlockPanel() {
      this.editorOpen = false;
    },
  },
  mounted() {
    //Test for potential redesign
    EventBus.$on("unlock-panel", this.unlockPanel);
    EventBus.$on("close_panel", this.closePanel);
    EventBus.$on("open_panel", this.openPanel);
    EventBus.$on("comparison_view_on", this.enableComparisonView);
  },
  components: {
    Variables,
    // Preview,
  },
};
</script>

<style lang="less">
#settingsPanel {
  width: 270px;
  min-width: 270px;
  background-color: var(--charcoal);
  color: var(--text-grey-primary);
  display: flex;
  flex-direction: column;
  // #variables {
    // 	// max-height: 350px;
  // 	// max-height: 95%;
  // }
 
  .collapser {
    background-color: var(--charcoal-115);
    border-bottom: 1px solid var(--charcoal-border);
    height: 40px;
    padding: 0 45px;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }

  .panel-area {
    flex: 1 1 auto;
    border-bottom: 1px solid var(--charcoal-border);
    padding: 30px 0 0 0;
    // height: 350px;

    &.collapsed {
      flex: none;
    }
  }

  &.collapsed {
    width: 68px;
    min-width: 68px;

    .collapser {
      padding: 0;
      justify-content: center;

      .variation-count {
        display: none;
      }
    }

    .panel-area {
      display: none;
    }
  }

  .disabled-btn {
    pointer-events: none;
    color: grey;
  }
  .flip-chevron {
    transform: rotate(180deg);
  }
}
</style>
